// stores/ui/uiStore.js
import { create } from "zustand";
import { flushCommissionAdjustments } from "../../new-gold-trading-platform/commission-step/commissionAdjustments";

const STEP_MODE_KEY = "admin-trading-step-mode";
const savedStepMode = localStorage.getItem(STEP_MODE_KEY);
const initialStepMode = savedStepMode === "step-commission" ? "step-commission" : "step-gold";
if (savedStepMode !== initialStepMode) localStorage.setItem(STEP_MODE_KEY, initialStepMode);

export const useUIStore = create((set, get) => ({
    windowWidth: window.innerWidth,
    gtpCounter: 0,
    fontSize: "20px",
    stepButtonTypeByNodeId: {},
    tradingStepMode: initialStepMode,

    toggleTradingStepMode: () => {
        flushCommissionAdjustments();
        const nextMode = get().tradingStepMode === "step-gold" ? "step-commission" : "step-gold";
        localStorage.setItem(STEP_MODE_KEY, nextMode);
        set({ tradingStepMode: nextMode, stepButtonTypeByNodeId: {} });
    },

    setWindowWidth: (w) => {
        set({ windowWidth: w });
        get().setFontSizeFromWidth(w); // now works
    },

    incrementCounter: () =>
        set(state => ({ gtpCounter: state.gtpCounter + 1 })),

    setFontSizeFromWidth: (width) => {
        let size = "20px";

        if (width < 300) size = `${width / 20}px`;
        else if (width < 500) size = `${width / 32}px`;
        else if (width < 800) size = `${width / 50}px`;
        else size = `${width / 100}px`;

        set({ fontSize: size });
    },

    // toggle per quantityDefinition
    toggleStepButtonType: (nodeId) =>
        set((state) => ({
            stepButtonTypeByNodeId: {
                ...state.stepButtonTypeByNodeId,
                [nodeId]: !(state.stepButtonTypeByNodeId?.[nodeId] ?? true),
            },
        })),

    setStepButtonType: (nodeId, value) =>
        set((state) => ({
            stepButtonTypeByNodeId: {
                ...state.stepButtonTypeByNodeId,
                [nodeId]: value,
            },
        })),

    getStepButtonType: (nodeId) => get().stepButtonTypeByNodeId?.[nodeId] ?? true,



}));
